import { DashboardLayout } from './DashboardLayout';
import { Toolbar } from './toolbar';

import type { PageHandleV2 } from '@/layouts/MainLayout/MainLayout.config';
import type { RouteObject } from 'react-router-dom';

export const dashboardRoutes: RouteObject[] = [
	{
		path: 'dashboard',
		children: [
			{
				index: true,
				element: <DashboardLayout />,
				handle: {
					title: 'Dashboard',
					displayTimeFilter: true,
					displayFilter: true,
					variant: 'transparent',
					actionsMenu: Toolbar,
				} satisfies PageHandleV2,
			},
		],
	},
];
